module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAYAAAC9pNwMAAABaElEQVR42u3WwUrEMBAA0Coe/AFF1INePPgNigh+hCCIJzGz2yQzyVYXYV0EEfV/POlhwW/Qix5E/6NOBKWblEJl1tMODLTTDI8hJW3211CGTrP/DjDoQNOLMjgYqxPtKvR71RwOh7NiqNL0Cr3eEl8/V3G+vgdDDz+pNJbKulwMRcSVcO+9X4zwZDvA0o0oGiLF62FRNMF5zzkvJOAUbYi8318Ikwc8geXRZjwvilVrz9YE0PZ4O9SSVwbfIlQcT1GetFsUy5WyAC6AyuHNqDzejMrjLVBZPJzdv5O3QMUm5y/WXFZFwdAhWDqSxDoa95V2x1Wc4fnoUMcBw5eSMGhXKONu43orOMfetkLcqcuyLGcmAoN1B98vh6FRnKGutDuZEEzn/Pyqts9SHwxeT+EpPIXHYM5HMG4rztDcDNOoto97QNNdI9z1fl0Z+uTFT0lyvUO0UdcXfuh4zXtdH2j8yJ3bjHu+AHkxpMHcHutnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/c-home_2x.png
// module id = 969
// module chunks = 0